import React, { useState } from "react";
import Item from "../components/Item";

const HistoryCarousel = ({ items }) => {
  const [currentSlide, setCurrentSlide] = useState(2);
  const [currentTransform, setCurrentTransform] = useState(0);

  const [prevSlideHeight, setPrevSlideHeight] = useState(0);
  const [currentHeight, setCurrentSlideHeight] = useState(0);
  const [nextSlideHeight, setNextSlideHeight] = useState(0);

  let slides = items.map((e, i) => {
    return (
      <Item
        {...e}
        heightElement={height => {
          if (i === currentSlide) {
            height !== 0 ? setCurrentSlideHeight(height) : null;
          } else {
            height !== 0 ? setNextSlideHeight(height) : null;
            height !== 0 ? setPrevSlideHeight(height) : null;
          }
        }}
        i={i} // It is the same as `key` prop but React don't want give access to `key` props.
        key={i}
        jumpTo={targetNumber => {
          setCurrentSlide(targetNumber);
          let diff;
          if (targetNumber > currentSlide) {
            diff = targetNumber - currentSlide;
            setCurrentTransform(currentTransform - prevSlideHeight * diff);
          } else {
            diff = currentSlide - targetNumber;
            setCurrentTransform(currentTransform + nextSlideHeight * diff);
          }
        }}
        active={i === currentSlide}
      />
    );
  });

  const PrevBtn = () => (
    <button
      className="carousel-arrow carousel-prev slick-arrow"
      disabled={currentSlide <= 0}
      onClick={() => {
        setCurrentSlide(currentSlide - 1);
        setCurrentTransform(currentTransform + prevSlideHeight);
      }}
    >
      Up
    </button>
  );

  const NextBtn = () => (
    <button
      className="carousel-arrow carousel-next slick-arrow"
      disabled={currentSlide === items.length - 1}
      onClick={() => {
        setCurrentSlide(currentSlide + 1);
        setCurrentTransform(currentTransform - prevSlideHeight);
      }}
    >
      Down
    </button>
  );

  let wrapperHeight = 2 * prevSlideHeight + currentHeight + 2 * nextSlideHeight;

  return (
    <>
      <p className="text-center">
        <PrevBtn />
      </p>
      <div
        style={{
          overflow: "hidden",
          height: `${wrapperHeight}px`
        }}
      >
        <div
          className="history-carousel__container"
          style={{
            transform: `translate3d(0px, ${currentTransform}px, 0px)`,
            transitionDuration: "0.8s"
          }}
        >
          {slides}
        </div>
      </div>
      <p className="text-center">
        <NextBtn />
      </p>
    </>
  );
};
export default HistoryCarousel;
